import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {StorageUtils} from '../../../utils/storage-utils';
import {RestService} from '../../../utils/rest-service';
import {JsonContainer} from '../../../utils/json-container';
import {ActivityLog} from './activity-log';


@Injectable()
export class ActivityLogService extends RestService {

    constructor(private client: HttpClient, private storageUtils: StorageUtils) {
        super(client, 'activityLog', storageUtils);
    }

    listLastLogs(callback: (result: JsonContainer, logs: ActivityLog[]) => void) {
        this.executeGet('listLastLogs', callback)
    }
}
